"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var recentlyRemovedFavorite_1 = require("./helpers/recentlyRemovedFavorite");
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var datapoints_1 = require("../datapoints");
var addRemoveFavoriteService_1 = require("../services/addRemoveFavoriteService");
var store_1 = require("../store/store");
var Store_1 = require("owa-mail-store/lib/store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Add or remove the given folderId from the favorite folder list
 * @param idToUpdate the id to remove
 * @param state the state which contains the favoritesFolderNodes and the folder to update
 */
exports.default = legacy_1.action('removeFavoriteFolder', datapoints_1.default.RemoveFavoriteFolder)(legacy_1.select({
    favoritesFolderNodes: function () { return store_1.default.favoritesFolderNodes; },
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
    folder: function (idToUpdate, isAdd) { return Store_1.default.folders.folderTable.get(idToUpdate); },
})(function removeFavorite(idToUpdate, actionSource, state) {
    // Check if favoritesFolderNodes doesn't contain the id
    if (!state.favoritesFolderNodes.has(idToUpdate)) {
        throw new Error('Cannot find the folder id in favorite folder list.');
    }
    // Remove from favorite from the store
    state.orderedFavoritesNodeIds.splice(state.orderedFavoritesNodeIds.indexOf(idToUpdate), 1);
    state.favoritesFolderNodes.delete(idToUpdate);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Record the last removed folder so we can correlate accidental removes
    recentlyRemovedFavorite_1.recordLastRemoveFavorite(idToUpdate);
    // Service request for FAI that used by outlook desktop
    addRemoveFavoriteService_1.default(state.folder, false /* isAdd */);
}));
//# sourceMappingURL=removeFavoriteFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/removeFavoriteFolder.js
// module id = 4656
// module chunks = 14